<div class="message-container" *ngIf="items.length <= 0 || loading">
  <div class="message-icon">
    <ng-container *ngIf="!loading">
      <i class="fa-duotone fa-circle-info fa-xl"></i>
    </ng-container>
    <ng-container *ngIf="loading">
      <i class="fa-duotone fa-spinner-third fa-spin"></i>
    </ng-container>
  </div>
  <div class="message-text">
    <ng-container *ngIf="loading">{{ '::LoadingPleaseWait' | abpLocalization }}...</ng-container>
    <ng-container *ngIf="!loading">{{ 'AbpUi::NoResults' | abpLocalization }}.</ng-container>
  </div>
</div>

<ul class="fa-ul mb-0">
  <li
    class="me-1 mb-2"
    *ngFor="let item of items; let i = index"
    [style.marginLeft]="(item.level - 1) * 12 + 'px'"
    (click)="onClickNode(item, i, $event)">
    <span class="fa-li" (click)="onClickToggleNode(item, i, $event)">
      <i *ngIf="loadingNodeId === item.department.id" class="fa-solid fa-spinner fa-spin"></i>
      <i
        *ngIf="!item.department.hasChildren"
        class="fa-solid fa-caret-down opacity-25 has-no-children"></i>
      <i
        *ngIf="item.department.hasChildren && loadingNodeId !== item.department.id"
        [ngClass]="item.expanded ? 'fa-solid fa-caret-down' : 'fa-solid fa-caret-right'"></i>
    </span>
    <span
      class="p-1 department-label"
      [ngClass]="selectedNodeId === item.department.id ? 'selected' : ''">
      {{ item.department.name }}
    </span>
  </li>
</ul>
